
window.theme.cart.progressBar = 0;
const updateProgressBar = () => {
  const progressBar = document.querySelector('#shipping-progress-bar');
  if (!progressBar)
    return;
  progressBar.style.width = window.theme.cart.progressBar + '%';
  progressBar.classList.add('on-transition');
  setTimeout(() => {
    window.theme.cart.progressBar = progressBar.dataset.width;
    progressBar.style.width = window.theme.cart.progressBar + '%';
  }, 10);
};
updateProgressBar();
window.theme.cart.render = async (delay = false, toggle = false) => {
  const sectionId = window.location.pathname.includes('/de') ? 'cart-drawer-de' : 'cart-drawer';
  const string = await fetch(`/?section_id=${sectionId}`, { headers: { "Cache-Control": "no-cache" } })
    .then(res => res.text())

  if (string.includes('Your Cart is empty'))
    window.theme.cart.progressBar = 0;
  const wrapper = new DOMParser()
    .parseFromString(string, 'text/html')
    .querySelector('.shopify-section');
  const drawerWrapper = document.getElementById('cart-drawer_wrapper');
  drawerWrapper.innerHTML = wrapper.innerHTML;


  window.theme.cart.toggle(toggle, delay);
  updateProgressBar();
  if (Shopify?.cartUpsellsApp) Shopify.cartUpsellsApp.init({
    sliderSelector: '.cart-upsells'
  })
};
class CartDrawer extends HTMLElement {
  mainDetailsToggle;
  insuranceModal;
  insuranceCheckbox;
  wrapper;
  drawer;

  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.insuranceModal = document.querySelector('#modal-insurance');
    this.insuranceCheckbox = document.querySelector('#bearabyInsurance');
    this.wrapper = this.children[0];
    this.drawer = this.querySelector('#cart-drawer');
    document.querySelector('#modal-insurance .icon-cross').addEventListener('click', this.closeInsurance.bind(this));
    if (this.querySelector('.info-insurance'))
      this.querySelector('.info-insurance').addEventListener('click', this.openInsurance.bind(this));
    if (this.querySelector('.cart__product-upsell'))
      this.handleCartUpsell()
  }
  handleCartUpsell() {
    const wrapper = this.querySelector('.cart__product-upsell')
    const button = this.querySelector('.btn')
    const selects = wrapper.querySelectorAll('.cart__product-upsell-dropdown')
    const imageEl = wrapper.querySelector('.cart__product-upsell-image img')
    const colorEl = wrapper.querySelector('.cart__product-upsell-option:first-child small')
    const sizeEl = wrapper.querySelector('.cart__product-upsell-option:last-child small')
    const priceEl = wrapper.querySelector('.cart__product-upsell-price p')
    const mainSelect = wrapper.querySelector('[name="hugget_id"]')

    wrapper.addEventListener('change', function (e) {
      e.target.closest('.cart__product-upsell-dropdown').classList.toggle('active')
      const attr = e.target.id.includes('hugget-color') ? 'color' : 'size';
      const color = wrapper.querySelector('[name="hugget_color"]:checked').value
      const size = wrapper.querySelector('[name="hugget_size"]:checked').value
      const selected = {}
      for (let index = 0; index < mainSelect.options.length; index++) {
        const option = mainSelect.options[index];
        if (option.dataset.color === color && option.dataset.size === size) selected.exact = option
        else if (option.dataset[attr] === e.target.value && !selected.closest) selected.closest = option
      }

      const selectedOption = selected.exact || selected.closest
      imageEl.src = selectedOption.dataset.image
      priceEl.dataset.price = selectedOption.dataset.price
      priceEl.dataset.discounted = selectedOption.dataset.discounted
      colorEl.dataset.value = selectedOption.dataset.color
      sizeEl.dataset.value = selectedOption.dataset.size
      mainSelect.value = selectedOption.value

      wrapper.querySelector(`[name="hugget_color"][value="${selectedOption.dataset.color}"]`).checked = true
      wrapper.querySelector(`[name="hugget_size"][value="${selectedOption.dataset.size}"]`).checked = true
    })

    selects.forEach(select => {
      select.addEventListener('click', () => {
        select.classList.toggle('active')
      })
    })

    button.addEventListener('click', function () {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: Number(mainSelect.value),
              properties: {
                'discount': '$10 off Huggets'
              }
            }
          ]
        })
      }).then(r => r.json())
        .then(res => {
          window.theme.cart.render();
        }).catch(err => {
          alert('there has been an error');
          console.err(err)
        })
    })
  }

  closeInsurance(e) {
    e.preventDefault();
    this.insuranceModal.removeAttribute('open');
    this.drawer.setAttribute('open', '');
  }
  openInsurance(e) {
    e.preventDefault();
    this.insuranceModal.setAttribute('open', '');
    this.drawer.removeAttribute('open');
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      if (this.hasAttribute('data-bundle')) {
        const keys = this.dataset.bundle.split(',');
        const item = this.closest('.cart-item');
        cartItems.removeBundle(keys[0], keys[1], item);
      }
      else
        cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
class CartItems extends HTMLElement {
  wrapper;
  form;
  insurance;
  constructor() {
    super();
    this.wrapper = this.querySelector('#main-cart-items');
    this.form = this.querySelector('form');
    this.insurance = this.querySelector('[name="insurance"]');
    if (this.wrapper) {
      this.wrapper.addEventListener('change', this.onChange.bind(this));
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      if (this.form.dataset.insurance)
        this.removeInsurance();
    }
  }
  onChange(e) {
    this.updateQuantity(e.target.dataset.index, e.target.value);
  }
  updateQuantity(line, quantity) {
    const cart = document.getElementById('cart');
    if (cart) {
      cart.classList.add('loading');
      if (quantity === 0) {
        const item = cart.querySelector('#CartItem-' + line);
        if (item)
          item.classList.add('cart-item-remove');
      }
    }
    const body = JSON.stringify({
      line,
      quantity,
    });
    fetch('/cart/change', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        window.theme.cart.render();
      }).catch((e) => {
        console.warn(e);
      }).finally(() => {
        if (cart)
          cart.classList.remove('loading');
      });
  }
  removeBundle(key1, key2, item) {
    const cart = document.getElementById('cart');
    if (cart) {
      cart.classList.add('loading');
      if (item)
        item.classList.add('cart-item-remove');
    }
    let updates = {};
    updates[key1] = 0;
    updates[key2] = 0;
    const body = JSON.stringify({
      updates,
    });
    fetch('/cart/update', { ...window.theme.fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        window.theme.cart.render();
      }).catch((e) => {
        console.warn(e);
      }).finally(() => {
        if (cart)
          cart.classList.remove('loading');
      });
  }
  handleSubmit(e) {
    e.preventDefault();
    this.form.classList.add('loading');
    const checkout = this.form.querySelector('#checkout');
    checkout.disabled = true;
    if (!this.insurance || !this.insurance.checked) {
      location.href = '/checkout';
      return;
    }
    const body = JSON.stringify({
      id: this.insurance.value,
      quantity: Number(this.insurance.dataset.quantity)
    });
    fetch('/cart/add', { ...window.theme.fetchConfig(), ...{ body } })
      .then(() => {
        location.href = '/checkout';
      })
      .catch(err => {
        console.error(err);
        e.target.submit();
      });
  }
  removeInsurance() {
    const body = JSON.stringify({
      id: this.form.dataset.insurance,
      quantity: 0,
    });
    fetch('/cart/change', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((parsedState) => {
        window.theme.cart.render();
      }).catch((e) => {
        console.warn(e);
      });
  }
}
customElements.define('cart-items', CartItems);
class NoteDrawer extends HTMLElement {
  textArea;
  characters;
  form;
  constructor() {
    super();
    this.textArea = this.querySelector('textarea');
    this.characters = this.querySelector('.note_characters span');
    this.form = document.querySelector('#cart');
    this.textArea.addEventListener('keyup', this.changeCharacters.bind(this));
    this.addEventListener('click', this.handleNote.bind(this));
  }
  changeCharacters() {
    const total = 200 - this.textArea.value.length;
    this.characters.innerHTML = total.toString();
  }
  handleNote(e) {
    e.preventDefault();
    let note = '';
    if (e.target.tagName !== 'BUTTON')
      return;
    else if (e.target.dataset.note === 'trigger') {
      if (this.hasAttribute('open'))
        this.removeAttribute('open');
      else
        this.setAttribute('open', '');
      return;
    }
    else if (e.target.dataset.note === 'add')
      note = this.textArea.value;
    this.form.classList.add('loading');
    const body = JSON.stringify({
      note,
    });
    fetch('/cart/update', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        window.theme.cart.render();
      }).catch((e) => {
        console.warn(e);
      })
      .finally(() => {
        this.form.classList.remove('loading');
      });
  }
}
customElements.define('note-drawer', NoteDrawer);
class CrossSell extends HTMLElement {
  button;
  image;
  color;
  form;
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.image = this.querySelector('.cross-sell_image');
    this.color = this.querySelector('.cross-sell_color');
    this.form = document.querySelector('#cart');
    this.addEventListener('change', this.changeColor.bind(this));
    this.button.addEventListener('click', this.addCross.bind(this));
  }
  changeColor(e) {
    const input = e.target;
    this.image.src = input.dataset.image;
    this.color.innerHTML = input.dataset.color;
  }
  addCross(e) {
    e.preventDefault();
    this.form.classList.add('loading');
    const id = this.querySelector('input:checked').value;
    const body = JSON.stringify({
      id,
    });
    fetch('/cart/add', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        window.theme.cart.render();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.form.classList.remove('loading');
      });
  }
}
customElements.define('cross-sell', CrossSell);
class QuantityInput extends HTMLElement {
  input;
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }
  onButtonClick(event) {
    event.preventDefault();
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    const cartItems = this.closest('cart-items');
    const productForm = this.closest('product-form')
    if (cartItems) cartItems.updateQuantity(this.input.dataset.index, parseInt(this.input.value));
    else if (productForm.querySelectorAll('[data-unit-price]') && this.dataset.changePrice) {
      const buttons = productForm.querySelectorAll('[data-unit-price]')
      const quantity = parseInt(this.input.value)
      buttons.forEach(button => {
        const price = parseInt(button.dataset.unitPrice.replace('$', ''))
        button.dataset.mobilePrice = '$' + (price * quantity)
      })
    }
  }
}
customElements.define('quantity-input', QuantityInput);

window.theme.cart.render(false, true)

